var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"avatar avatar--bordered"},[_c('picture',[_c('img',{attrs:{"src":require("assets/images/faq-img-04.jpg"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"avatar avatar--moved"},[_c('picture',[_c('img',{attrs:{"src":require("assets/images/faq-img-02.jpeg"),"alt":""}})])])])
}]

export { render, staticRenderFns }